import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=67625fc0&scoped=true&"
import script from "./CreatePassword.vue?vue&type=script&lang=js&"
export * from "./CreatePassword.vue?vue&type=script&lang=js&"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&id=67625fc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67625fc0",
  null
  
)

export default component.exports